export default "__VITE_PUBLIC_ASSET__fc62a875__"